import ChinaFlag from '@intelligence/assets/imgs/CasualWordlWide/china.png';
import USAFlag from '@intelligence/assets/imgs/CasualWordlWide/usa.png';
import JapanFlag from '@intelligence/assets/imgs/CasualWordlWide/japan.png';
import KoreaFlag from '@intelligence/assets/imgs/CasualWordlWide/korea.png';
import TurkeyFlag from '@intelligence/assets/imgs/CasualWordlWide/turkey.png';
import UkraineFlag from '@intelligence/assets/imgs/CasualWordlWide/ukraine.png';
import RussiaFlag from '@intelligence/assets/imgs/CasualWordlWide/russia.png';


/**
 * 全球游戏异动日报 Tab 枚举
 */
export enum WorldWideTab {
  Mobile = 'mobile',
  Steam = 'steam',
  Roblox = 'roblox',
}

/**
 * 区域配置
 */
export interface RegionConfig {
  /** 国旗图片 */
  flagImg: string;
  /** 区域特色样式 class */
  className: string;
  /** 中文名称 */
  nameZh: string;
  /** 英文名称 */
  nameEn: string;
  /** 国家代码（用于 getCountryFlag） */
  countryCode: string;
}

/** 接口 country_region 值 -> 区域配置映射 */
export const REGION_CONFIG_MAP: Record<string, RegionConfig> = {
  '国区': {
    flagImg: ChinaFlag,
    className: 'dbi-worldwide--china',
    nameZh: '中国区',
    nameEn: 'Mainland China',
    countryCode: 'cn',
  },
  '美区': {
    flagImg: USAFlag,
    className: 'dbi-worldwide--usa',
    nameZh: '美国区',
    nameEn: 'United States',
    countryCode: 'us',
  },
  '日区': {
    flagImg: JapanFlag,
    className: 'dbi-worldwide--japan',
    nameZh: '日本区',
    nameEn: 'Japan',
    countryCode: 'jp',
  },
  '韩区': {
    flagImg: KoreaFlag,
    className: 'dbi-worldwide--korea',
    nameZh: '韩国区',
    nameEn: 'South Korea',
    countryCode: 'kr',
  },
  '土区': {
    flagImg: TurkeyFlag,
    className: 'dbi-worldwide--turkey',
    nameZh: '土耳其区',
    nameEn: 'Turkey',
    countryCode: 'tr',
  },
  '乌区': {
    flagImg: UkraineFlag,
    className: 'dbi-worldwide--ukraine',
    nameZh: '乌克兰区',
    nameEn: 'Ukraine',
    countryCode: 'ua',
  },
  '俄区': {
    flagImg: RussiaFlag,
    className: 'dbi-worldwide--russia',
    nameZh: '俄罗斯区',
    nameEn: 'Russia',
    countryCode: 'ru',
  },
};

/** 获取区域配置，未匹配时返回默认值 */
export const getRegionConfig = (countryRegion: string): RegionConfig => {
  return REGION_CONFIG_MAP[countryRegion] || {
    flagImg: '',
    className: '',
    nameZh: countryRegion,
    nameEn: countryRegion,
    countryCode: '',
  };
};

